import Block from "../Block";
import './BlockAction.css';
import BlockChild from "../BlockChild/BlockChild";
import Menu from "../Menu/Menu";
import imageActionPreview from "/src/features/editor/image/action_preview.png";
import BlockLinkEnd from "../BlockLinkEnd/BlockLinkEnd";
import ActionType from "../../../data/constant/types/ActionType";
import editorAction from "../../../actions/editorAction";
import { useState } from "react";

function BlockAction({object_id, name, x, y, children, action_type, lowVersion, data, is_statistic}) {

    if( children) {
        children.sort((a, b) => a.index - b.index)
    }
    
    const { updateBlockStatistic } = editorAction()

    //console.log(is_statistic)

    const type = action_type ? action_type.name : 'default'
    const content = ActionType[type];
    const exception = (type == "condition" || type == "keyword_redirection");
    var [isStatistic, setIsStatistic] = useState(is_statistic);

    const block = {
        name, x, y, id : object_id, imageLow : imageActionPreview, lowVersion, type : {name : type}, data, className : "action", childrenBlocks : children
    }

    const updateStatistic = () => {
        if(isStatistic == 0) isStatistic = 1;
        else if(isStatistic == 1) isStatistic = 2;
        else isStatistic = 0;

        updateBlockStatistic(object_id, isStatistic);
        setIsStatistic(isStatistic)
    }

    return (
        <Block {...block}>
            {!lowVersion && 
                <>
                    {  type != 'default' && <BlockLinkEnd parent_block_id={object_id} className="action" style={{left: "-15px", top: "60px", transform: "rotate(270deg)"}}/> }
                    <Menu className="action" id={object_id}/>
                    <div className="block_action_icon"></div>
                    { exception ? <div className={isStatistic ? (isStatistic == 1 ? 'block_action_stat enabled' : 'block_action_stat special') : 'block_action_stat'} onClick={updateStatistic}></div> : ''}
                    <label className="block_action_title">{name}</label>
                    <div className="action_innerblock">{content}</div>
                    { (!exception && type != 'default') && <BlockChild className="action" style={{left: "185.5px", top: "-115px", transform: "rotate(270deg)"}} zero={true} parent_block_id={object_id} object_id={children[0].object_id}/>}
                </>
            }
            { exception && children && 
                children.map((child,index) => child.index != 0 && 
                <BlockChild key={child.object_id} lowVersion={lowVersion} object_id={child.object_id} parent_block_id={object_id}  className="action" style={{width: "200px", top: (80 + (index * 40)) + "px"}} label={child.text}/>
            )}
        </Block>
    )
}

export default BlockAction;